<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <div class="tagView">
                <span class="goback" @click="goback"><i class="el-icon-back"></i> 返回</span>
                <div class="title_aside"></div>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>计费规则</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div style="margin-top:30px">
                <iframe :src="frameSrc" :style="{height: height}" frameborder="0" scrolling="no"></iframe>
            </div>
        </div>
    </el-row>
</template>

<script>
export default {
    data() {
        return {
            frameSrc:process.env.VUE_APP_RULES+'/billingRules.html',
            height:'auto',
        };
    },

    components: {},

    computed: {},

    created() {},

    mounted() {
        window.addEventListener("message",(event)=>{
            console.log(event)
            if (event && event.data && typeof event.data === 'string') {
                let obj = JSON.parse(event.data)
                if (obj.type === 'setHeight') {
                    this.height = obj.data + 'px'
                }
            }
        }, false)
    },
    methods:{
        goback(){
            zhuge.track('用户中心_立即购买_计费规则返回',()=>{
                this.$router.push({path:'/userAccount/buy'})
            });
        }
    }
};
</script>
<style lang="less" scoped>
.tagView{
    position: relative;
    .goback{
        position: absolute;
        right:0;
        top:-50px;
        display: block;
        color:#999999;
        cursor: pointer;
        &:hover{
            color:#3F7DF7;
        }
    }
}
iframe{
    width: 100%;
}
table{
    width:100%;
    color:#333;
    font-size: 14px;
    border-collapse: separate;
    border-spacing: 0;
    border: 1px #ccc;
    .platform{
        span{
            color:#999999;
        }
    }
    th{
        padding:20px;
        font-weight: 600;
        background: #E0E0E0;
    }
    td{
        padding:13px;
        line-height: 25px;
    }
    tr th:first-child,
    tr:nth-child(2) td:first-child,
    tr:nth-child(3) td:first-child,
    tr:nth-child(7) td:first-child,
    tr:nth-child(12) td:first-child{
        text-align: center;
        border-left: 1px solid #ccc;
    }
    tr:nth-child(2) td:nth-child(2),
    tr:nth-child(3) td:nth-child(2),
    tr:nth-child(7) td:nth-child(2),
    tr:nth-child(12) td:nth-child(2){
        text-align: center;
    }
    tr th:last-child,tr td:last-child {
        border-right: 1px solid #ccc;
    }
    tr td{
        border-bottom: 1px solid #ccc;
        border-right: 1px solid #ccc;
    }
    tr td:nth-child(1){
        text-align: center;
    }
    tr td:last-child{
        color:#999;
        padding-left: 25px;
    }

    tr:first-child th:first-child {
        border-top-left-radius: 12px;
    }
    tr:first-child th:last-child {
        border-top-right-radius: 12px;
    }
    tr:nth-child(12) td:first-child {
        border-bottom-left-radius: 12px;
    }
    tr:last-child td:last-child {
        border-bottom-right-radius: 12px;
    }

}
.descrition{
    font-size: 14px;
    margin-top:20px;
    color:#999;
    li{
        line-height: 30px;
    }
}
</style>
